import { StringKey } from 'dictionaries/string-key.enum';
import { HeardFrom, InquiryType, SectorType } from 'types';
import z from 'zod';

export const contactSchema = z.object({
  firstName: z.string().min(1, { error: () => StringKey.FIRST_NAME_REQUIRED }),
  lastName: z.string().min(1, { error: () => StringKey.LAST_NAME_REQUIRED }),
  email: z.email({
    error: (issue) => (!issue.input ? StringKey.EMAIL_REQUIRED : StringKey.EMAIL_INVALID),
  }),
  inquiryType: z.enum(InquiryType, { error: () => StringKey.INQUIRY_TYPE_REQUIRED }),
  heardFrom: z.enum(HeardFrom, { error: () => StringKey.HEARD_FROM_REQUIRED }),
  message: z.string().min(1, { error: () => StringKey.MESSAGE_REQUIRED }),
  agreed: z
    .boolean({ error: () => StringKey.AGREE_TERMS_REQUIRED })
    .refine((val) => val, { message: StringKey.AGREE_TERMS_REQUIRED }),
});

export const requesDemoSchema = z.object({
  firstName: z.string().min(1, { error: () => StringKey.FIRST_NAME_REQUIRED }),
  lastName: z.string().min(1, { error: () => StringKey.LAST_NAME_REQUIRED }),
  email: z.email({
    error: (issue) => (!issue.input ? StringKey.EMAIL_REQUIRED : StringKey.EMAIL_INVALID),
  }),
  phoneNumber: z
    .string()
    .regex(/^(\+?[1-9]{1}[0-9]{6,15})$/, { error: () => StringKey.PHONE_NUMBER_REQUIRED }),
  organizationName: z.string().min(1, { error: () => StringKey.ORGANIZATION_NAME_REQUIRED }),
  sectorType: z.enum(SectorType, { error: () => StringKey.SECTOR_TYPE_REQUIRED }),
  country: z
    .string({ error: () => StringKey.COUNTRY_REQUIRED })
    .min(1, { error: () => StringKey.COUNTRY_REQUIRED }),
  agreed: z
    .boolean({ error: () => StringKey.AGREE_TERMS_REQUIRED })
    .refine((val) => val, { message: StringKey.AGREE_TERMS_REQUIRED }),
});

export const joinWaitlistSchema = z.object({
  email: z.email({
    error: (issue) => (!issue.input ? StringKey.EMAIL_REQUIRED : StringKey.EMAIL_INVALID),
  }),
});
